import { GET_SUPER_ADMIN_LOCATION_BY_Agents_ERROR, GET_SUPER_ADMIN_LOCATION_BY_Agents_LOADING, GET_SUPER_ADMIN_LOCATION_BY_Agents_SUCCESS } from "../type/Constant";

let initialState = {
  getLocationByAgents: {
    loading: false,
    data: null,
    error: false,
    errors: null,
    success: false,
    pagination:{}
  },
};

export default function getLocationByAgents(state = initialState, action) {
  switch (action.type) {
    
    case GET_SUPER_ADMIN_LOCATION_BY_Agents_LOADING:
      return { ...state, getLocationByAgents: { ...state.getLocationByAgents, loading: true, error: false, errors: [], success: false } };

    case GET_SUPER_ADMIN_LOCATION_BY_Agents_SUCCESS:
      return { ...state, getLocationByAgents: { ...state.getLocationByAgents, loading: false, error: false, errors: [], success: true, data: action.response.data, pagination: action.pagination } };

    case GET_SUPER_ADMIN_LOCATION_BY_Agents_ERROR:
      return { ...state, getLocationByAgents: { ...state.getLocationByAgents, loading: false, error: true, errors: action.errors, success: false, data: null } };

    default:
      return state;
  }
}
